























































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { storeDnrConsent } from "@/store/modules/DnrConsentStore";
import DnrConsentSvc from "@/services/DnrConsent";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storeDokter } from "@/store/modules/dokter";
import { getHumanDateTime } from "@/utility/DateUtils";
import { alasanTtdMengunciHapus, slotTandaTanganDokumen } from "@/utils/hapusSetelahTtd";
import FormConsentSection from "./dnr/FormConsentSection.vue";
import DetailConsentSection from "./dnr/DetailConsentSection.vue";
import FormInstruksiSection from "./dnr/FormInstruksiSection.vue";
import DetailInstruksiSection from "./dnr/DetailInstruksiSection.vue";
import ReviewDnrSection from "./dnr/ReviewDnrSection.vue";

@Component({
  components: {
    CardModalTtd,
    FormConsentSection,
    DetailConsentSection,
    FormInstruksiSection,
    DetailInstruksiSection,
    ReviewDnrSection
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardDnr extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  panels: number[] = [0, 1];
  showFormConsent = false;
  isEditingConsent = false;
  isEditingInstruksi = false;
  modalTtd = false;
  modalSaksi = false;
  signRole = "";
  saksiRole = "";
  saksiNama = "";
  deleting = false;
  savingConsent = false;
  savingInstruksi = false;
  formConsentValid = false;
  formInstruksiValid = false;

  formConsent: any = this.getEmptyConsent();
  formInstruksi: any = this.getEmptyInstruksi();

  mounted() {
    storeDnrConsent.getByRegister(this.register);
    if (!storeDokter.listAll.length) {
      storeDokter.act_dokter_all();
    }
  }

  getEmptyConsent() {
    return {
      dpjp_id: null,
      pj_nama: "",
      pj_tempat_lahir: "",
      pj_tgl_lahir: "",
      pj_alamat: "",
      pj_no_telepon: "",
      pj_hubungan: "",
      pj_hubungan_lainnya: "",
      konfirmasi_info_resusitasi: false,
      konfirmasi_manfaat_risiko: false,
      konfirmasi_tanggung_jawab: false,
      tgl_persetujuan: localISODate()
    };
  }

  getEmptyInstruksi() {
    return {
      instruksi_no_rjp: false,
      instruksi_tanpa_intubasi: false,
      instruksi_suportif: false,
      alasan_dnr: "",
      dasar_keputusan: ""
    };
  }

  get loading() { return storeDnrConsent.loading; }
  get stateConsent() { return storeDnrConsent.consent; }
  get stateuser() { return userModule.user; }
  get dokterList() { return storeDokter.listAll; }

  get isDnrDibatalkan() {
    return this.stateConsent?.is_dnr_dibatalkan;
  }

  get hasInstruksi() {
    if (!this.stateConsent) return false;
    return this.stateConsent.instruksi_no_rjp || this.stateConsent.instruksi_tanpa_intubasi || this.stateConsent.instruksi_suportif;
  }

  get isPage1Signed() {
    const c = this.stateConsent;
    return c && c.signed_penyetuju && c.signed_dpjp && c.signed_saksi_rs && c.signed_saksi_keluarga;
  }

  get isPage2Signed() {
    const c = this.stateConsent;
    return c && c.signed_dpjp_instruksi && c.signed_saksi_keluarga_instruksi;
  }

  get isFullySigned() {
    return this.isPage1Signed && this.isPage2Signed;
  }

  get canCreate() {
    if (this.readOnly) return false;
    return userModule.canAccessForm("persetujuan_dnr", "create");
  }

  get canDelete() {
    if (this.readOnly) return false;
    if (!userModule.canAccessForm("persetujuan_dnr", "edit")) return false;
    return this.lolosGerbangTtdHapus;
  }

  get lolosGerbangTtdHapus() {
    const c = this.stateConsent;
    if (!c) return false;
    return !alasanTtdMengunciHapus(
      c.creator_user_id,
      [
        { ditandatangani: c.signed_penyetuju, penandaTanganId: null },
        ...slotTandaTanganDokumen(c.signed_dpjp, c.signature_dpjp),
        { ditandatangani: c.signed_saksi_rs, penandaTanganId: c.saksi_rs?.id },
        { ditandatangani: c.signed_saksi_keluarga, penandaTanganId: null },
        ...slotTandaTanganDokumen(c.signed_dpjp_instruksi, c.signature_dpjp_instruksi),
        { ditandatangani: c.signed_saksi_keluarga_instruksi, penandaTanganId: null }
      ],
      this.stateuser?.id
    );
  }

  get canEditConsent() {
    if (this.readOnly) return false;
    if (!userModule.canAccessForm("persetujuan_dnr", "edit")) return false;
    return this.stateConsent && !this.isFullySigned;
  }

  get canEditInstruksi() {
    if (this.readOnly) return false;
    if (!userModule.canAccessForm("persetujuan_dnr", "edit")) return false;
    return this.stateConsent && !this.isFullySigned;
  }

  get canSignPenyetuju() {
    if (this.readOnly) return false;
    return this.stateConsent && !this.stateConsent.signed_penyetuju;
  }

  get canSignDpjp() {
    if (this.readOnly) return false;
    if (!this.stateConsent || this.stateConsent.signed_dpjp) return false;
    return this.stateConsent.dpjp?.id == this.stateuser?.id;
  }

  get canSignSaksiRs() {
    if (this.readOnly) return false;
    if (!this.stateConsent || this.stateConsent.signed_saksi_rs) return false;
    if (this.stateConsent.saksi_rs && this.stateConsent.saksi_rs.id != this.stateuser?.id) return false;
    return true;
  }

  get canMarkSaksiKeluarga() {
    if (this.readOnly) return false;
    return this.stateConsent && !this.stateConsent.signed_saksi_keluarga;
  }

  get canSignDpjpInstruksi() {
    if (this.readOnly) return false;
    if (!this.stateConsent || this.stateConsent.signed_dpjp_instruksi) return false;
    if (!this.hasInstruksi) return false;
    return this.stateConsent.dpjp?.id == this.stateuser?.id;
  }

  get canMarkSaksiKeluargaInstruksi() {
    if (this.readOnly) return false;
    return this.stateConsent && this.hasInstruksi && !this.stateConsent.signed_saksi_keluarga_instruksi;
  }

  get canAddReview() {
    return this.isFullySigned;
  }

  get canDeleteState() {
    if (this.readOnly) return false;
    return this.lolosGerbangTtdHapus;
  }

  get canEditConsentState() {
    if (this.readOnly) return false;
    return this.stateConsent && !this.isFullySigned;
  }

  get canEditInstruksiState() {
    if (this.readOnly) return false;
    return this.stateConsent && !this.isFullySigned;
  }

  // ============ CONSENT SECTION 1 ============

  startEditConsent() {
    const c = this.stateConsent;
    this.formConsent = {
      dpjp_id: c.dpjp?.id || null,
      pj_nama: c.pj_nama || "",
      pj_tempat_lahir: c.pj_tempat_lahir || "",
      pj_tgl_lahir: c.pj_tgl_lahir || "",
      pj_alamat: c.pj_alamat || "",
      pj_no_telepon: c.pj_no_telepon || "",
      pj_hubungan: c.pj_hubungan || "",
      pj_hubungan_lainnya: c.pj_hubungan_lainnya || "",
      konfirmasi_info_resusitasi: c.konfirmasi_info_resusitasi,
      konfirmasi_manfaat_risiko: c.konfirmasi_manfaat_risiko,
      konfirmasi_tanggung_jawab: c.konfirmasi_tanggung_jawab,
      tgl_persetujuan: c.tgl_persetujuan || localISODate()
    };
    this.isEditingConsent = true;
  }

  cancelEditConsent() {
    this.isEditingConsent = false;
    this.formConsent = this.getEmptyConsent();
  }

  async simpanConsent() {
    this.savingConsent = true;
    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        ...this.formConsent,
        pj_hubungan_lainnya: this.formConsent.pj_hubungan === "Lainnya" ? this.formConsent.pj_hubungan_lainnya : null
      };

      let resp;
      if (this.stateConsent && this.isEditingConsent) {
        resp = await DnrConsentSvc.update(this.stateConsent.id, payload);
      } else {
        resp = await DnrConsentSvc.create(payload);
      }

      if (resp.data.status == "1") {
        appModule.NoticeDelay("Persetujuan DNR berhasil disimpan");
        this.isEditingConsent = false;
        this.showFormConsent = false;
        this.formConsent = this.getEmptyConsent();
        storeDnrConsent.getByRegister(this.register);
      }
    } finally {
      this.savingConsent = false;
    }
  }

  // ============ INSTRUKSI SECTION 2 ============

  startEditInstruksi() {
    const c = this.stateConsent;
    this.formInstruksi = {
      instruksi_no_rjp: c.instruksi_no_rjp,
      instruksi_tanpa_intubasi: c.instruksi_tanpa_intubasi,
      instruksi_suportif: c.instruksi_suportif,
      alasan_dnr: c.alasan_dnr || "",
      dasar_keputusan: c.dasar_keputusan || ""
    };
    this.isEditingInstruksi = true;
  }

  cancelEditInstruksi() {
    this.isEditingInstruksi = false;
    this.formInstruksi = this.getEmptyInstruksi();
  }

  async simpanInstruksi() {
    this.savingInstruksi = true;
    try {
      const resp = await DnrConsentSvc.updateInstruksi(this.stateConsent.id, this.formInstruksi);
      if (resp.data.status == "1") {
        appModule.NoticeDelay("Instruksi DNR berhasil disimpan");
        this.isEditingInstruksi = false;
        this.formInstruksi = this.getEmptyInstruksi();
        storeDnrConsent.getByRegister(this.register);
      }
    } finally {
      this.savingInstruksi = false;
    }
  }

  // ============ TANDA TANGAN ============

  openTtd(role: string) {
    this.signRole = role;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    const signFns: Record<string, Function> = {
      penyetuju: DnrConsentSvc.signPenyetuju,
      dpjp: DnrConsentSvc.signDpjp,
      saksi_rs: DnrConsentSvc.signSaksiRs,
      dpjp_instruksi: DnrConsentSvc.signDpjpInstruksi
    };

    const labels: Record<string, string> = {
      penyetuju: "Penyetuju",
      dpjp: "DPJP",
      saksi_rs: "Saksi RS",
      dpjp_instruksi: "DPJP Instruksi"
    };

    const fn = signFns[this.signRole];
    if (!fn) return;

    const resp = await fn(this.stateConsent.id, { password });

    if (resp.data.status == "1") {
      this.modalTtd = false;
      appModule.NoticeDelay(`Berhasil Tanda Tangan ${labels[this.signRole]}`);
      appModule.addMsgTtd("");
      storeDnrConsent.getByRegister(this.register);
    } else {
      appModule.addMsgTtd(resp.data.message);
      this.modalTtd = true;
    }
  }

  // ============ SAKSI KELUARGA (MANUAL) ============

  openMarkSaksi(role: string) {
    this.saksiRole = role;
    this.saksiNama = "";
    if (role === "keluarga" && this.stateConsent?.saksi_keluarga_nama) {
      this.saksiNama = this.stateConsent.saksi_keluarga_nama;
    }
    if (role === "keluarga_instruksi" && this.stateConsent?.saksi_keluarga_instruksi_nama) {
      this.saksiNama = this.stateConsent.saksi_keluarga_instruksi_nama;
    }
    this.modalSaksi = true;
  }

  async submitMarkSaksi() {
    const fn = this.saksiRole === "keluarga"
      ? DnrConsentSvc.markSaksiKeluarga
      : DnrConsentSvc.markSaksiKeluargaInstruksi;

    const field = this.saksiRole === "keluarga"
      ? "saksi_keluarga_nama"
      : "saksi_keluarga_instruksi_nama";

    const resp = await fn(this.stateConsent.id, { [field]: this.saksiNama });

    if (resp.data.status == "1") {
      this.modalSaksi = false;
      appModule.NoticeDelay("Berhasil menandai Saksi Keluarga");
      storeDnrConsent.getByRegister(this.register);
    }
  }

  // ============ REVIEW ============

  async submitReview(review: any) {
    const resp = await DnrConsentSvc.addReview(this.stateConsent.id, review);
    if (resp.data.status == "1") {
      appModule.NoticeDelay("Review DNR berhasil ditambahkan");
      storeDnrConsent.getByRegister(this.register);
    }
  }

  // ============ OTHER ============

  cetakPdf() {
    DnrConsentSvc.print(this.stateConsent.id);
  }

  async remove() {
    if (!this.canDeleteState) return;
    const q = confirm("Anda yakin akan menghapus Persetujuan DNR ini?");
    if (q && !this.deleting) {
      this.deleting = true;
      try {
        const resp = await DnrConsentSvc.destroy(this.stateConsent.id);
        if (resp?.status == 1) {
          appModule.NoticeDelay(resp.message);
          storeDnrConsent.getByRegister(this.register);
        }
      } finally {
        this.deleting = false;
      }
    }
  }
}
